import { UAParser } from 'ua-parser-js';

const getMajor = (version) => {
  if (version == null) {
    return undefined;
  }
  const major = typeof (version) === 'string' ? version.replace(/[^\d.]/g, '').split('.')[0] : undefined;
  return Number(major) || undefined;
};

const checkUA = () => {
  try {
    const parser = new UAParser();
    const browser = parser.getBrowser();
    const os = parser.getOS();
    const name = browser.name;
    const major = getMajor(browser.version);
    const osMajor = getMajor(os.version);
    const isOldChrome = name == 'Chrome' && major < 70;
    const isOldEdge = name == 'Edge' && major < 79;
    const isOldFirefox = name.includes('Firefox') && major < 62;
    const isOldSafari = name == 'Safari' && major < 11;
    const isOldIOS = os.name == 'iOS' && osMajor < 11;
    return isOldChrome
      || isOldEdge
      || isOldFirefox
      || isOldSafari
      || isOldIOS;
  } catch (error) {
    console.log('Failed to parse UA', error);
  }
  return false;
};

export default checkUA;